import {
    ComponentStoryChatMessageText,
    ComponentStoryChatMessageTextButton,
    SceneChatMessagesDynamicZone,
} from "@/components/pages/stele/Chat";

let idCounter = 0;

function generateChatMessage(
    text: string,
    awaitingLast?: boolean,
    isUser?: boolean,
    disableTitle?: boolean,
): SceneChatMessagesDynamicZone {
    const chatMessage: ComponentStoryChatMessageText = {
        __typename: "ComponentStoryChatMessageText",
        id: idCounter,
        duration: 2,
        delay: 0,
        text,
        awaitingButtonId: awaitingLast === true ? idCounter - 1 : undefined,
        isUser,
        disableTitle: disableTitle === true ? true : false,
    };

    idCounter++;

    return chatMessage;
}

function generateChatMessageButton(
    buttonText: string,
    buttonTextTwo: string,
    buttonTextThree?: string,
): SceneChatMessagesDynamicZone {
    const chatMessage: ComponentStoryChatMessageTextButton = {
        __typename: "ComponentStoryChatMessageTextButton",
        id: idCounter,
        duration: 0,
        delay: 0,
        buttonText,
        buttonTextTwo,
        buttonTextThree,
        buttonId: idCounter + 1,
        awaitingButtonId: undefined,
    };

    idCounter++;
    idCounter++;

    return chatMessage;
}

function generateChatMessages(): SceneChatMessagesDynamicZone[] {
    const chatMessages: SceneChatMessagesDynamicZone[] = [
        generateChatMessage(
            "Hi, schöne Grüße aus der Zukunft! Total irre, mein jüngeres Ich kennenzulernen! Alles gut bei dir, gerade?",
        ),
        generateChatMessageButton(
            "Alles im grünen Bereich",
            "Könnte besser sein",
            "Erinnerst du dich etwa nicht an 2024?",
        ),

        generateChatMessage("Alles im grünen Bereich", true, true),
        generateChatMessage(
            "Top. Hab auch nur die besten Erinnerungen an 2024 … Taylor Swift ist noch als echte Person aufgetreten. Und ein Brötchen kostete noch keine 6 Euro.",
        ),
        generateChatMessageButton(
            "Taylor Swift ist nicht mehr echt?!",
            "Ein Brötchen für 6 Euro?!",
            "Sag mal, wie alt bist du eigentlich?",
        ),

        generateChatMessage("Taylor Swift ist nicht mehr echt?!", true, true),
        generateChatMessage(
            "Doch, aber die treten nur noch als Avatar auf. Mick Jagger auch, der wird heute 140. Naja, ich schreibe aus dem Jahr 2068. Es ist schon ne Menge Zeit vergangen. Guck dir das hier mal an:",
        ),
        generateChatMessage("Sogar Stuttgart21 ist letztes Jahr fertig geworden …", false, false, true),
        generateChatMessageButton(
            "Krass. Und da wohnst du?",
            "Dir scheint es ja gut zu gehen",
            "Erzähl mir mehr von der Zukunft",
        ),

        generateChatMessage("Krass. Und da wohnst du?", true, true),
        generateChatMessage("Ja, schon seit fast 20 Jahren."),
        generateChatMessage(
            "Freu dich drauf – KI-Concierge-Service, Flugtaxi-Landeplatz auf dem Solar-Deck und begehbarer Kühlschrank. Ist übrigens ne Eigentumswohnung. Dafür musst du allerdings noch ‘n bisschen was tun, liebes Junior-Ich …",
            false,
            false,
            true,
        ),
        generateChatMessageButton("Wie hast du das gemacht?", "Was denn?"),

        generateChatMessage("Wie hast du das gemacht?", true, true),
        generateChatMessage(
            "Naja, du weißt ja – Geld war nie so unser Ding. Aber die Krisen, Inflation … es wurde nicht ruhiger. Daher hab ich irgendwann jemanden gefragt, der mir geholfen hat. Kann ich sehr empfehlen …",
        ),
        generateChatMessageButton("Wen hast du gefragt?", "Inflation?"),

        generateChatMessage("Wen hast du gefragt?", true, true),
        generateChatMessage(
            "Ähm, gute Frage, ist lange her. Frau … oder Herr … Dingens. Ich komm’ nicht drauf. Ich such’ dir den Kontakt raus und schick ihn dir, okay? Wollen wir noch ein Selfie als Erinnerung machen?",
        ),
        generateChatMessageButton("Ja, klar!", "Nein, danke"),
    ];

    return chatMessages;
}

export default generateChatMessages;
